'use strict'

export class SignUp {
    constructor () {
        this.form = document.querySelector('.signup-form-wrapper')
        if(this.form) {
            this.#addTeamToURLmeta();
            this.#preselectGoal();
        }
    }



    #addTeamToURLmeta(){
        const select = this.form.querySelector('select[name="team_id"]');
        const selectWrapper =  select?.closest(".levcharity_select_wrapper");

        window.addEventListener("pageshow", () => selectWrapper.classList.remove("disabled"))
        if(select){
            select.addEventListener('change', (e) => {
                const selectedOption = e.target.options[e.target.selectedIndex];
                const teamName = selectedOption?.textContent.trim() || '';
                const teamImageSrc = selectedOption?.getAttribute('data-image-src') || '';
                const teamIDHiddenInput = document.querySelector('input[name="team_id"]');
                console.log(teamIDHiddenInput);
                const teamId = e.target.value;
                this.#saveTeamCardData(
                    teamName,
                    teamImageSrc,
                    teamId
                );
                let baseUrl = window.location.origin + window.location.pathname;
                if(baseUrl.endsWith('/')) {
                    baseUrl = baseUrl.slice(0, -1);
                }
                baseUrl = baseUrl.replace(/\/join-team\/?$/, '');

                const newUrl = `${baseUrl}/join-team?team_id=${teamId}`;
                selectWrapper.classList.add("disabled");
                window.location.href = newUrl;
            });
        }

    }


    #saveTeamCardData(teamName = '', src = '', id = 0) {
        const cookieValue = JSON.stringify({
            name: teamName,
            image_src: src,
            id: id,
            action: 'join-team'
        });

        document.cookie = `team_card_data=${encodeURIComponent(cookieValue)}; path=/;`;
    }

    #preselectGoal() {
        const goalSelect = document.querySelector('.fundraising_campaign_goal');
        if (goalSelect) {
            goalSelect.value = 1800
        }
    }



}